var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head__utils"},[_c('span',{staticClass:"trigger-search",on:{"click":_vm.triggerSearch}},[_c('svg',{attrs:{"viewBox":"0 0 16 17"}},[_c('use',{attrs:{"xlink:href":"#icons--search","width":"100%","height":"100%"}})])]),(_vm.logged)?_c('MobileNavBtn'):_vm._e(),_c('LangSwitcher'),_c('UserLink',{attrs:{"logged":_vm.logged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }